import React from "react";

class BasicView extends React.Component {
  render() {
    return (
      <>
        <div className="App">
          <div className="container-fluid" >
            <div className="row" >
              {this.props.children}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default BasicView;
